import React, { useCallback, useEffect } from 'react';
import { Dispatch, RootState } from '../../../../store/store';
import { connect } from 'react-redux';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import SpinnerLoader from '../../../../components/SpinnerLoader/SpinnerLoader';
import { IRecipeStepEditable } from '../../../../types/recipes-types';
import { recipeStepsFullPath, validationStepSchema } from '../../constants';
import { RecipeStepFormCard } from '../../Components/RecipeStepFormCard';

type ComponentProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch>;

const RecipeStepEdit: React.FC<ComponentProps> = ({
  step,
  getStep,
  updateStep,
  reset,
}) => {
  const { id, step_id } = useParams();
  const navigate = useNavigate();

  const onSubmitHandler = useCallback(
    async (values: IRecipeStepEditable) => {
      await updateStep({ recipeid: id, stepId: step_id, body: values });
      navigate(generatePath(recipeStepsFullPath, { id }));
    },
    [id, step_id, navigate, updateStep]
  );

  useEffect(() => {
    getStep({ recipeid: id, stepId: step_id });
  }, [id, step_id]);

  useEffect(() => {
    return () => {
      reset();
    };
  }, []);

  if (!step) {
    return (
      <div className="flex w-full justify-center">
        <SpinnerLoader />
      </div>
    );
  }

  return (
    <RecipeStepFormCard
      initialValues={step}
      validationSchema={validationStepSchema}
      submitButtonName="Update"
      formName={`Update Recipe Step #${step.order}`}
      onSubmit={onSubmitHandler}
    />
  );
};
const mapState = (state: RootState) => ({
  step: state.recipes.step,
});

const mapDispatch = (dispatch: Dispatch) => ({
  getStep: dispatch.recipes.getStep,
  updateStep: dispatch.recipes.updateStep,
  reset: dispatch.recipes.resetStep,
});

export default connect(mapState, mapDispatch)(RecipeStepEdit);
